import { Injectable } from '@angular/core';
import { McticHttpClient } from '@mctic/ng-core';
import { Rda } from '../shared/model/';
import { Observable } from 'rxjs';
import { EnvioRda } from '../shared/model/envio-rda.model';

@Injectable({
  providedIn: 'root'
})

export class RdaService {

  private readonly endpoint = '/sepin-backend/rest/rda';

  constructor(
    private readonly http: McticHttpClient) {
  }

  enviar(rda: Rda) {
    return this.http.post(this.endpoint, rda);
  }

  obterRdaEnviado(idRda: number): Observable<EnvioRda> {
    return this.http.get<EnvioRda>(`${this.endpoint}/enviado/rda/${idRda}`);
  }

  obterEnvioRdaPorIdComposicaoRda(idComposicaoRda: number): Observable<EnvioRda> {
    return this.http.get<EnvioRda>(`${this.endpoint}/enviado/composicao-rda/${idComposicaoRda}`)
  }

  obterEnvioRdasUsuario(): Observable<EnvioRda[]> {
    return this.http.get<EnvioRda[]>(`${this.endpoint}/usuario`)
  }


}
